import {daysBetween} from 'shared/utils/dateTime';
import {
  DEFAULT_BUDGET_AMOUNT as defaultAmount,
  DEFAULT_BUDGET_DAYS_COUNT as defaultDaysCount,
} from 'shared/const';

export function isDefault(budget: Budget): boolean {
  const {initial, spent, added, finishDate, startDate} = budget;

  return (
    initial === defaultAmount &&
    !spent &&
    !added &&
    daysBetween(finishDate, startDate) === defaultDaysCount
  );
}
